export const detectUserLocation = () =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      position => {
        if (position) {
          resolve(position);
          return;
        }
        reject(`position is ${position}`);
      },
      err => {
        reject(`${err.message}`);
      },
    );
  });

export default detectUserLocation;
